import { ContactEnvelopePageSizeType, MerchantType } from "@/enums/enums";
import { AddressDetailModel, MerchantAddressModel } from "../address/addressModel";
import { DepartmentModel, OrdinaryPersonModel } from "../contact/contactModel";
import { UserInfoModel } from "../user/userModel";
import { CredentialModel, ElementDataMerchantContactInfoModel, ElementDefaultModel } from "./documentModel";
import { SettingContactEnvelopeDocumentTemplateModel } from "./settingDocumentTemplate";

export class ContactEnvelopeOnlineViewModel {
  document!: ContactEnvelopeDocumentDetailModel;
  template!: SettingContactEnvelopeDocumentTemplateModel;
  merchantId!: number;
  transactionId!: number;
  transactionType!: number;
  financeType!: number;
  expenseType!: number;
  credential!: CredentialModel;
  headerOptionType!: number;
}

export class ContactEnvelopeDocumentDetailModel {
  data!: ContactEnvelopeDocumentModel;
  version!: number;
}

export class ContactEnvelopeDocumentModel {
  merchant!: DocumentMerchantEnvelopeModel;
  contact!: DocumentContactEnvelopeModel;
  createdDateTime!: Date;
  createdUser!: UserInfoModel;
}

export class DocumentEnvelopeInfoModel {
  name!: string;
  merchantType!: MerchantType;
  taxNumber!: string;
  branchCode!: string;
  phoneNumber!: string;
  faxNumber!: string;
  email!: string;
  website!: string;
}

export class DocumentMerchantEnvelopeModel extends DocumentEnvelopeInfoModel {
  merchantId!: number;
  isVat!: boolean;
  line!: string;
  logoUrl!: string;
  user!: UserInfoModel;
  registerAddress!: AddressDetailModel;
  shippingAddress!: AddressDetailModel;
}

export class DocumentContactEnvelopeModel extends DocumentEnvelopeInfoModel {
  contactId!: number;
  contactCode!: string;
  isOrdinaryPerson!: boolean;
  ordinaryPerson!: OrdinaryPersonModel;
  persons!: Array<ContactPersonEnvelopeModel>;
  registerAddress!: AddressDetailModel;
  shippingAddress!: AddressDetailModel;
}

export class HeaderContactEnvelopeDocumentModel {
  pageSize!: ContactEnvelopePageSizeType;
  merchantLogo!: ElementDefaultModel;
  merchant!: ElementMerchantEnvelopeModel;
}

export class ContactEnvelopeDocumentTemplateModel {
  transactionType!: number;
  header!: HeaderContactEnvelopeDocumentModel;
  contact!: ElementContactEnvelopeModel;

  constructor() {
    this.header = new HeaderContactEnvelopeDocumentModel();
    this.contact = new ElementContactEnvelopeModel();
  }
}

export class ElementMerchantEnvelopeModel extends ElementDataMerchantContactInfoModel {
  merchantAddressTemplate!: MerchantAddressModel;
  merchantType!: MerchantType;
  merchantName!: string;
  merchantAddress!: AddressDetailModel;
  merchantTaxId!: string;
  merchantBranchCode!: string;
}

export class ElementContactEnvelopeModel extends DocumentContactEnvelopeModel {
  isShowContactName!: boolean;
  isShowContactPosition!: boolean;
  isShowContactTel!: boolean;
  personTemplate!: ContactPersonEnvelopeModel;
}

export class ContactPersonEnvelopeModel {
  contactPersonId!: number;
  email!: string;
  fullName!: string;
  firstName!: string;
  lastName!: string;
  ordinaryPerson!: OrdinaryPersonModel;
  phoneNumber!: string;
  department!: DepartmentModel;
  isArchived!: boolean;
  isMainPerson!: boolean;

  constructor() {
    this.fullName = "";
  }
}
